import { useEffect, useMemo } from 'react';

import { getRouteApi } from '@tanstack/react-router';

import useResizeObserver from '@/hooks/use-resize-observer';
import { parseSearchParamsToSearchQuery } from '@/utils/parseSearchParamsToSearchQuery';

const route = getRouteApi('/_authenticated/_sidebar-layout/projects/');

import { EstateGrid } from '../estates/components/estate-grid';
import { EstatesList } from '../estates/components/estate-list';
import { useProjects } from './api/projects';

export const ProjectsSection = () => {
  const { view, filters, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const isDesktopView = useResizeObserver(768);

  const parsedFilters = parseSearchParamsToSearchQuery(filters);

  const queryEstatesOptions = useMemo(
    () => ({
      query: {
        ...(Object.keys(parsedFilters).length ? { filters: parsedFilters } : {}),
        ...(sort &&
          (sort.by || sort.order) && {
            sort: {
              ...(sort.by && { by: sort.by }),
              ...(sort.order && { order: sort.order }),
            },
          }),
        pageSize: view === 'map' ? 999 : 20,
      },
    }),
    [view, parsedFilters, sort]
  );

  const { data: projects } = useProjects(queryEstatesOptions);

  useEffect(() => {
    if (!isDesktopView && view !== 'grid') {
      navigate({
        search: (prev: Record<string, string>) => ({ ...prev, view: 'grid' }),
      });
    }
  }, [isDesktopView, navigate, view]);

  if (view === 'grid') {
    return <EstateGrid data={projects} filters={parsedFilters} type="project" />;
  }

  return <EstatesList data={projects} filters={parsedFilters} route={route} type="project" />;
};
